<template>
  <div class="stripe">
    <aside v-if="alreadySubscribed" data-test="currently-subscribed" class="stripe-success">
      Currently Subscribed
    </aside>
    <form v-else-if="!success" v-on:submit.prevent="subscribe" class="stripe-form">
      <!-- <div class="stripe-label">Pay with card</div> -->
      <div class="stripe-container">
        <div ref="card" id="card-element" v-on:change="showError" />
        <i v-if="error">{{error}}</i>
        <div class="stripe-submit">
          <ff-button v-if="!processing" :text="'Subscribe'" :action="subscribe" :options="{ width: 100 }" type="submit"/>
          <ff-button v-else :text="'Processing'" :action="subscribe" :disabled="true" :options="{ width: 100 }"/>
        </div>
      </div>
    </form>
    <strong v-else class="stripe-success">
      ✓ Success!
    </strong>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'
import { mapState } from 'vuex'
import analytics from '../../mixins/analytics'
import email from '../../mixins/email'

import FFButton from '../DesignSystem/FFButton'

export default {
  name: 'stripe-payment',
  components: {
    'ff-button': FFButton
  },
  props: [
    'tier'
  ],
  mixins: [ analytics, email ],
  data () {
    return {
      stripe: null,
      elements: null,
      error: '',
      card: null,
      processing: false,
      success: false
    }
  },
  methods: {
    showError(e) {
      this.processing = false
      if (typeof(e) === 'string') {
        this.error = e
      } else if (e.error) {
        this.error = e.error.message
      } else {
        this.error = ''
      }
    },
    async handlePaymentThatRequiresAction(subscription, payment_method_id) {
      const payment_intent = subscription.latest_invoice.payment_intent
      const status = payment_intent.status

      if (status === 'requires_payment_method') {
        return this.showError('That card didn\'t work')
      }

      if (status === 'requires_action') {
        await this.stripe
          .confirmCardPayment(payment_intent.client_secret, {
            payment_method: payment_method_id,
          })
          .then((result) => {
            if (result.error) {
              this.showError(result)
            } else {
              if (result.paymentIntent.status === 'succeeded') {
                return this.handleSuccess()
              }
            }
          })
          .catch((error) => {
            this.showError(error)
          })
      }
    },
    subscribe () {
      this.processing = true
      this.$nextTick(async () => {
        if (this.alreadySubscribed) {
          console.error('already subscribed but tried to subscribe')
          return
        }

        let result = await this.stripe.createPaymentMethod({
          type: 'card',
          card: this.card
        })

        if (result.error) {
          return this.showError(result)
        }

        const payment_method_id = result.paymentMethod.id

        let func = firebase.functions().httpsCallable('stripe-createSubscription')
        let sub = await func({
          channelId: this.channel_id,
          tier: this.tier,
          paymentMethodId: payment_method_id
        })

        if (sub.data.status === 'active') {
          return this.handleSuccess()
        }

        await this.handlePaymentThatRequiresAction(sub.data, payment_method_id, false)
      })
    },
    handleSuccess () {
      this.success = true
      this.track('[Channel] Subscribed', {
        tier: this.tier
      })
      // Email the owner
      const user = this.user.email ? `Email: <strong>${this.user.email}<strong/>` : `Someone`
      this.emailToOwner({
        html: `${user} subscribed to your channel.<br/><br/>Keep up the good work!`,
        subject: `🤑New paid subscriber to your channel ${this.channel.name}!`
      })
      return this.$router.push({name: 'channel-landing', query: { s: true }})
    }
  },
  computed: {
    ...mapState(['user', 'channel_id', 'channel']),
    alreadySubscribed() {
      if (!this.user) return
      let uid = this.user.uid

      if (this.channel.fans && this.channel.fans[uid]) {
        let tier = this.channel.fans[uid].tier
        return tier === this.tier
      }
      return false
    }

  },
  created () {
    this.stripe = window.Stripe(`${process.env.VUE_APP_STRIPE_PK}`)
    this.elements = this.stripe.elements()
  },
  mounted () {
    this.card = this.elements.create('card')
    this.card.mount('#card-element')
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .stripe-submit {
    margin: auto;
    padding: 0 $unit-1;
  }

  .stripe-container {
    background-color: $color-white;
    border-radius: .5rem;
    padding-bottom: $unit-1;
  }

  .stripe-label {
    @include h2;
    text-align: center;
  }

  #card-element {
    padding: 1rem;

    ::v-deep
    .InputElement {
      font-size: $fontSize-normal;
      color: $color-dark;
    }
  }

  .stripe-success {
    @include success;
    width: fit-content;
  }

</style>
